module.exports = __webpack_public_path__ + "static/media/ottawa-38.d8c66842.jpg";